import React from 'react';

import { Player, BigPlayButton } from 'video-react';
import 'video-react/dist/video-react.css';

function svgPlaceholder(width, height) {
  return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}"%3E%3C/svg%3E`;
}

export default function View(props) {
  const { data, index, currentIndex } = props;
  const overscan = 1;
  const inBounds = Math.abs(currentIndex - index) <= overscan;

  let component;

  switch (data.type) {
    case 'image':
      component = (
        <img
          className="react-images__view-image react-images__view-image--isModal file-viewer__image"
          src={inBounds ? data.url : svgPlaceholder(data.width, data.height)}
          alt={data.label}
        />
      );
      break;
    case 'video':
      component = (
        <div className="file-viewer__video">
          {inBounds ? (
            <Player playsInline poster={data.poster} src={data.url}>
              <BigPlayButton position="center" />
            </Player>
          ) : (
            <img
              className="react-images__view-image react-images__view-image--isModal file-viewer__image"
              src={svgPlaceholder(data.width, data.height)}
              alt={data.label}
            />
          )}
        </div>
      );
      break;
    default:
      break;
  }

  return (
    <div className="react-images__view react-images__view--isModal file-viewer__wrapper">
      {component}
    </div>
  );
}
